<template>
  <agile :ref="theId">
    <div class="slide" v-for="image in images" :key="image">
      <img :src="image" />
    </div>
    <div slot="prevButton"></div>
    <div slot="nextButton"></div>
  </agile>
</template>

<script>
import { VueAgile } from "vue-agile";
export default {
  name: "Carrousel",
  components: {
    agile: VueAgile
  },
  props: {
    theId: {
      type: String,
      required: true
    },
    images: {
      type: Array,
      required: true
    }
  },
  methods: {
    reloadTheSlider() {
      this.$refs[this.theId].reload();
      this.$refs[this.theId].goTo(0);
    }
  },
  mounted() {
    // console.log("on the mounted");
    this.reloadTheSlider();
  },
  updated() {
    // console.log("on the updated");
    this.reloadTheSlider();
  }
};
</script>

<style lang="scss">
.agile {
  &__actions {
    margin-bottom: 2rem;
    @media #{$md-and-up} {
      justify-content: center;
    }
  }
  &__dot {
    width: 1rem;
    height: 1rem;
    border-radius: 100%;
    margin: 0 1rem;
    overflow: hidden;
    &--current button {
      background: get($theme, "primary") !important;
    }
    button {
      width: 100%;
      height: 100%;
      background: get($colors, "grey");
    }
  }
  &__nav-button {
    position: relative;
    background: get($colors, "white");
    box-shadow: get($shadows, "dark");
    border-radius: 100%;
    width: 3rem;
    height: 3rem;
    @media #{$md-and-up} {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
    }
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url("~@/assets/images/ic_back.svg") no-repeat center;
      background-size: 50%;
    }
    &--next {
      right: 2rem;
      &:before {
        transform: rotate(180deg);
      }
    }
    &--prev {
      left: 2rem;
    }
  }
}
</style>
